import { Component, HostListener, inject, Inject, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Mtrwd } from '../entity/Mtrwd-angular';
import { JkRichEditorComponent, MaterialModule } from 'jk-service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { QuillHtmlComponent } from 'jk-service';
import { JkBaseOption } from 'jk-service';
import { jkRestReturn } from 'jk-service';
import { JkDialogEditComponent } from 'jk-service';
import { MtrwdService, templateUrlConfigMtr } from '../_service_mtr';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';



@Component({
  selector: 'app-mtrwd-edit',
  templateUrl: './mtrwd-edit.component.html',
  styles: [], // ### 讓dialog可以resize dialogResizeCss
  standalone: true,
  imports: [JackBaseComponentModule, AdvComModule,
    MaterialModule,
    FormsModule,
    JkRichEditorComponent,
    QuillModule],
  providers: [],// ### jackie add
})
export class MtrwdEditComponent extends JkDialogEditComponent<MtrwdService, Mtrwd> {

  constructor(injector: Injector,
    public override dialogRef: MatDialogRef<MtrwdEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(injector, dialogRef, data);
  }

  WD014Change(newValue: string): void {
    setTimeout(async () => {
      this.srv.item = this.item;
      await this.srv.WD014Change(newValue, this.ownForm);
      this.cloneField(this.srv.item, this.item);
      this.cdr.detectChanges();
    });
  }

  WD021Change(newValue: string): void {
    setTimeout(async () => {
      this.srv.item = this.item;
      await this.srv.WD021Change(newValue, this.ownForm);
      this.cloneField(this.srv.item, this.item);
      this.cdr.detectChanges();
    });
  }
}
